module.exports = __webpack_public_path__ + "static/media/logout.420d571c.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/notifications/logout.ogg
// module id = 2777
// module chunks = 0